import { IClaimNote } from '@/types';
import { AsyncRefWrapper } from '@/classes/asyncRefWrapper';
import { NoteControllerApi } from '@/hooks/api/noteControllerApi';

export class NoteUpdate extends AsyncRefWrapper<void> {
  public constructor(private _noteId: number) {
    super(undefined);
  }

  public updateNote(note: IClaimNote): Promise<void> {
    return this.loadFrom(NoteControllerApi.updateNote(this._noteId, note));
  }
}
